import React from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { EditSvg } from '../../../assets/svg-icon-components/EditSvg';
import { TrashSvg } from '../../../assets/svg-icon-components/TrashSvg';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { RhButton, RhButtonMode } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { RhCardListItem } from '../../core/RhCardListItem';
import { colors } from '../../core/Styles';
import { MissionStatementProps } from '../containers/MissionStatementContainer';
import MarkdownIt from 'markdown-it';
import { IoInformationCircleOutline } from 'react-icons/io5';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const markdownItIns = require('markdown-it-ins');
const md = new MarkdownIt({ html: true }).use(markdownItIns);

export const MissionStatementScreen = (props: MissionStatementProps) => {
  return (
    <DashboardWrapper>
      <DashboardHeader
        title="Mission Statement"
        actions={[
          props.isLoading && <CircleSpinner key="spinner" size={20} color={colors.primary} />,
          <RhButton key="add" title="Add section" onClick={props.userClickedAddSection} />,
        ]}
      />
      <div className="grid grid-cols-5 gap-5">
        {/* 1st column */}
        <div className="col-span-3">
          <RhCard className="space-y-5">
            {!props.missionStatements.length &&
              (props.isLoading ? <CircleSpinner size={20} color={colors.primary} /> : <div>No sections yet</div>)}
            {props.missionStatements.map((missionStatement, i) => (
              <RhCardListItem
                key={missionStatement.id}
                description={
                  <div
                    // The styling is defined in App.css
                    className="mission-statement"
                    dangerouslySetInnerHTML={{ __html: md.render(missionStatement.content) }}
                  />
                }
                isDescriptionTruncated={false}
                imageUrl={missionStatement.imageUrl}
                imageMode="minirect"
                topRightActions={[
                  <RhButton
                    key="edit"
                    mode={RhButtonMode.subtle}
                    prefixSvg={EditSvg}
                    iconColor={colors.grey}
                    onClick={() => {
                      props.userClickedEditSection(missionStatement.id);
                    }}
                  />,
                  <RhButton
                    key="delete"
                    mode={RhButtonMode.subtle}
                    prefixSvg={TrashSvg}
                    iconColor={colors.grey}
                    onClick={() => {
                      props.userClickedDeleteSection(missionStatement.id);
                    }}
                  />,
                ]}
                trailing={() => <div />}
              />
            ))}
          </RhCard>
        </div>
        {/* 2nd column */}
        <div className="col-span-2">
          <RhCard>
            <div className="space-x-2 flex">
              <IoInformationCircleOutline color="blue" size={24} />
              <div>Mission Statements appear on the Risen Hope app home screen.</div>
            </div>
          </RhCard>
        </div>
      </div>
    </DashboardWrapper>
  );
};
